module.exports = __webpack_public_path__ + "img/40.ad007e51.jpg";